import React from 'react';
import { map } from 'ramda';
import styled from 'styled-components';

// import es7 from '../../../../../assets/technologies/es7.png';
// import redux from '../../../../../assets/technologies/redux.png';
// import webpack from '../../../../../assets/technologies/webpack.png';
// import react from '../../../../../assets/technologies/react.png';
import { Label } from '../../../../common';

// const techLogo = {
//   es7,
//   redux,
//   webpack,
//   react,
// };


const Technology = ({ items }) => (
  <div>
    <SmallTitle>Technologie:</SmallTitle>
    <TechnologyList>{map(item => <Label key={item}>{item}</Label>)(items)}</TechnologyList>
  </div>
);

// const TechnologyItem = styled.img`
//   height: 48px;
//   width: 51px;
//   object-fit: cover;
// `;

const SmallTitle = styled.div`
  color: #8E9AA7;
  font-size: 14px;
  padding-bottom: 8px;
`;

const TechnologyList = styled.div`
  display: flex;
  align-items: center;

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

export default Technology;
